import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { githubAuth, GitHubUser } from '../services/githubAuth';
import Logo from './Logo';

const Header: React.FC = () => {
  const [user, setUser] = useState<GitHubUser | null>(null);

  useEffect(() => {
    setUser(githubAuth.getUser());
  }, []);

  const handleLogout = () => {
    githubAuth.logout();
    setUser(null);
    window.location.href = '/';
  };

  return (
    <header className="sticky top-0 z-10 bg-charcoal-bg/85 backdrop-blur-md border-b border-charcoal-border text-gray-900">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2.5 hover:opacity-80 transition-opacity">
            <Logo size={30} />
            <span className="font-display text-2xl font-extrabold text-gray-900">
              GitHub<span className="text-lime">Mate</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1 mr-2">
            <Link
              to="/learn"
              className="text-sm font-semibold text-gray-700 hover:text-lime transition-colors px-3 py-1.5 rounded-full hover:bg-charcoal-card"
            >
              Learn Vulnerabilities
            </Link>
            <Link
              to="/ai-coding-tools"
              className="text-sm font-semibold text-gray-700 hover:text-lime transition-colors px-3 py-1.5 rounded-full hover:bg-charcoal-card"
            >
              AI Coding Tools
            </Link>
          </nav>

          <div className="flex items-center gap-3">
            {user ? (
              <>
                <img
                  src={user.avatar_url}
                  alt={user.login}
                  className="w-8 h-8 rounded-full ring-2 ring-lime"
                />
                <span className="text-sm text-muted hidden sm:block">
                  {user.name || user.login}
                </span>
                <button
                  onClick={handleLogout}
                  className="flex items-center gap-1.5 text-sm text-muted hover:text-gray-900 transition-colors px-2 py-1 rounded-full hover:bg-charcoal-card"
                >
                  <LogOut className="w-4 h-4" />
                  <span className="hidden sm:block">Sign out</span>
                </button>
              </>
            ) : (
              <button
                onClick={githubAuth.login}
                className="btn-primary flex items-center gap-2 text-sm !py-2 !px-5"
              >
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0 0 24 12c0-6.63-5.37-12-12-12z" />
                </svg>
                Login with GitHub
              </button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
